import React, {useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '@Hooks/useGlobalRequestHandler';
import { useDispatch } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
import './LogoutPage.scss';

export default function LogoutPage() {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const className = 'logoutPage';

    useEffect(() => {
        dispatch({ type: 'RESET' });
        localStorage.clear();
        apiClient.cancelAll();
        const interval = setInterval(() => {
            navigate('/', { replace: true });
        }, 1000);
        return () => {
            clearInterval(interval);
        };
    }, []);

    return(
        <div className={className}>
            <div className = {className + '__loader'}>
                <CircularProgress size='6rem' sx={{color: '#667eea'}} />
            </div>
            <div className={className + '__logout'}>
                <div className={className + '__logout__icon'}>👋</div>
                <div className={className + '__logout__t1'}>You have been logged out</div>
                <div className={className + '__logout__subtitle'}>Redirecting to login page...</div>
                <div className={className + '__logout__status'}>
                    <span className={className + '__logout__status__dot'}></span>
                    <span>Signing out</span>
                </div>
            </div>
        </div>
    )
}
